<pannel [title]="'Groupements de parcs'">
<nav class="navbar">
	<div class="navbar navbar-left">
		<button class="btn btn-primary" (click)="onGroupementParcCreationRequest()">Ajouter un Groupement de parcs</button>
	</div>
</nav>
<div class="mat-elevation-z8">
	<mat-progress-bar mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>
	<table mat-table matSort [dataSource]="dataSource">

		<ng-container matColumnDef="id">
			<th mat-header-cell *matHeaderCellDef mat-sort-header> ID </th>
			<td mat-cell *matCellDef="let gp"> {{ gp.id }} </td>
		</ng-container>
	
		<ng-container matColumnDef="antenneNom">
			<th mat-header-cell *matHeaderCellDef mat-sort-header> Antenne </th>
			<td mat-cell *matCellDef="let gp"> {{ gp.antenneNom }} </td>
		</ng-container>
	
		<ng-container matColumnDef="code">
			<th mat-header-cell *matHeaderCellDef mat-sort-header> Code </th>
			<td mat-cell *matCellDef="let gp"> {{ gp.code }} </td>
		</ng-container>
	
		<ng-container matColumnDef="libelle">
			<th mat-header-cell *matHeaderCellDef mat-sort-header> Libellé </th>
			<td mat-cell *matCellDef="let gp"> {{ gp.libelle }} </td>
		</ng-container>
	
		<ng-container matColumnDef="parcs">
			<th mat-header-cell *matHeaderCellDef mat-sort-header> Parcs </th>
			<td mat-cell *matCellDef="let gp"> {{ gp.parcs }} </td>
		</ng-container>
	
		<ng-container matColumnDef="actions">
			<th mat-header-cell *matHeaderCellDef>&nbsp;</th>
			<td mat-cell *matCellDef="let gp">
				<a alt="Modifier" title="Modifier" href="#" onclick="return false;"
					[ngClass]="'icon-button-blue'" (click)="onGroupementParcModificationRequest(gp)" >
					<i class="fa-solid fa-pen-to-square"></i>
				</a>
				&nbsp;
				<a alt="Supprimer" title="Supprimer" href="#"
					[ngClass]="'icon-button-red'"
					onclick="return false;"
					(click)="onGroupementParcSuppressionRequest(gp)" >
					<i class="fa fa-trash"></i>
				</a>
			</td>
		</ng-container>

		<tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
		<tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
	</table>
	<mat-paginator #paginator showFirstLastButtons [pageSizeOptions]="[5, 10, 20, 50]" 
		[pageSize]="10" aria-label="Choisissez une page">
	</mat-paginator>
</div>
<nav class="navbar footer">
	<div class="navbar navbar-left">
		<button class="btn btn-primary" (click)="onGroupementParcExportRequest()">Exporter</button>
	</div>
</nav>
</pannel>

<edit-groupement-dialog (gpCreate)="onGroupementCreate()" (gpUpdate)="onGroupementUpdate()" >
</edit-groupement-dialog>